import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import {
  CHARGE_PHASE,
  COMBAT_PHASE,
  DURING_GAME,
  HERO_PHASE,
  MOVEMENT_PHASE,
  SAVES_PHASE,
  SHOOTING_PHASE,
  WOUND_ALLOCATION_PHASE,
} from 'types/phases'

const Spells = {
  //Lore of Hysh
  'Lore of Hysh': {
    effects: [
      {
        name: `Beacon of Hysh: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords Wizard to cast this spell, pick a visible friendly non-Monster Lumineth Realm-Lords unit wholly with 12" of them to be the target, then make a casting roll of 2D6.
        Effect: Until the start of your next turn, if the unmodified hit roll for an attack that targets that friendly unit is 1-3, the attack fails and the attack sequence ends.`,
        when: [HERO_PHASE],
      },
      {
        name: `Overwhelming Heat: Casting value of 7`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords Wizard to cast this spell, pick a visible enemy unit within 18" of them to be the target, then make a casting roll of 2D6. 
        Effect: Halve the target's Move characteristic until the start of your next turn, then roll a dice. If the roll equals or exceeds the target's Save characteristic, inflict D3 mortal damage on it.`,
        when: [HERO_PHASE],
      },
      {
        name: `Piercing Refraction: Casting value of 7`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords Wizard to cast this spell, pick a visible enemy unit within 18" of them to be the target, then make a casting roll of 2D6. 
        Effect: Roll a dice for each model in the target unit. For each 5+, inflict 1 mortal damage on the target.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Lore of the Awakened Realms': {
    effects: [
      {
        name: `Focused Erosion: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords Wizard to cast this spell, pick a visible enemy unit within 18" of them to be the target, then make a casting roll of 2D6.
        Effect: Subtract 1 from the Rend characteristic of the target's weapons until the start of your next turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Elemental Push: Casting value of 6`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords Wizard to cast this spell, pick a visible friendly Lumineth Realm-Lords unit wholly within 12" of them that was not set up this turn to be the target, then make a casting roll of 2D6. Subtract 1 from the roll if the target is in combat.
        Effect: The target can move up to 5". It can pass through the combat ranges of enemy units but cannot end that move in combat.`,
        when: [HERO_PHASE],
      },
      {
        name: `Realmshield: Casting value of 7`,
        desc: `Declare: Pick a friendly Lumineth Realm-Lords Wizard to cast this spell, then make a casting roll of 2D6. 
        Effect: Until the start of your next turn, friendly Lumineth Realm-Lords units have Ward (5+) while they are wholly within 12" of the caster.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Lore of Prismatic Resonance': {
    effects: [
      {
        name: `Beam of Hysh: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Lumineth Realm-lords Wizard to cast this spell, pick a visible enemy unit within 18" of them that has not been picked to be the target of this ability this battle round to be the target, then make a casting roll of 2D6. Add 1 to the casting value of this spell for each time it has been successfully cast by a friendly Wizard this turn. 
        Effect: Inflict D3+X mortal damage on the target, where X is the number of times, to a maximum of 3, that this spell has previously been cast by a friendly Wizard this turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Unseen Force: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Lumineth Realm-lords Wizard to cast this spell, pick a visible enemy unit within 18" of them to be the target, then make a casting roll of 2D6. 
        Effect: Until the start of your next turn, the target cannot use Run abilities. In addition, if that enemy unit has already been picked to be the target of this ability this battle round, subtract 1 from hit rolls for the targets combat attacks.`,
        when: [HERO_PHASE],
      },
      {
        name: `Beacons of Protection: Casting value of 6 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Lumineth Realm-lords Wizard to cast this spell, then make a casting roll of 2D6. 
        Effect: Until the start of your next turn, ignore the first damage point allocated to friendly non-Monster Lumineth Realm-lords units each phase while they are wholly within 9" of a friendly Lumineth Realm-lords Wizard. Add 3" to the range for each additional time this spell has been successfully cast by a friendly Wizard this battle round.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Aelementiri Conclave (AoR)': {
    effects: [
      {
        name: `Vexing Spirits: Casting value of 7`,
        desc: `Declare: Pick a friendly Aelementiri Conclave Wizard to cast this spell, pick a visible enemy unit within 12" of them to be the target, then make a casting roll of 2D6. 
        Effect: For the rest of the turn, the target cannot use commands.`,
        when: [HERO_PHASE],
      },
      {
        name: `Cycle Manifestation: Casting value of 6`,
        desc: `Declare: Pick a friendly Aelementiri Conclave Wizard to cast this spell, pick 1 of the friendly Manifestation below that is not on the battlefield, then make a casting roll of 2D6
        Sanctum of Amyntok
        Hyshian Twinstones
        Rune of Petrification
        Effect: If there is already a friendly Manifestation from the list above on the battlefield, it is immediately banished. Then, set up the Manifestation you picked within 1" of the caster and visible to them. If that Manifestation is a Sanctum of Amyntok, it must instead be set up wholly within 12" of the caster, more than 3" from all enemy units, and with its 3 parts touching each other so that they form a ring.`,
        when: [HERO_PHASE],
      },
      {
        name: `Sanctum of Amyntok - Sigil of Yngra - Passive`,
        desc: `Effect: While a friendly unit with a Health characteristic of 10 or less is wholly inside the ring formed by this Manifestation:
        That unit is not visible to enemy units.
        Enemy abilities that would target that unit must target this Manifestation instead.`,
        when: [DURING_GAME],
      },
      {
        name: `Hyshian Twinstones - Reservoir of Power - Passive`,
        desc: `Effect: Each time a unit (friendly or enemy) successfully casts a spell while it is within 12" of this Manifestation, give this Manifestation 1 arcane charge point.
        This Manifestation can have a maximum of 6 arcane charge points.`,
        when: [HERO_PHASE],
      },
      {
        name: `Hyshian Twinstones - Release Arcane Charge - Once Per Turn - Reaction: You declared a Spell or Unbind ability for a Lumineth Realm-Lords Wizard within 3" of this Manifestation`,
        desc: `Effect: Add this Manifestation's arcane charge points to the casting roll or unbinding roll. Then, reset this Manifestation's arcane charge points to 0.`,
        when: [HERO_PHASE],
      },
      {
        name: `Rune of Petrification - Turn to Stone`,
        desc: `Effect: Roll a D3 for each enemy unit within 6" of this Manifestation. On a 2+, inflict an amount of mortal damage on that enemy unit equal to the roll. If an enemy unit has 3 mortal damage inflicted on it by this ability, it has Strike-Last for the rest of the turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(Spells, 'spell')
